var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "fix-height row excel-upload-cover" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4" },
          [
            _c("q-uploader", {
              ref: "excelUpload",
              staticClass: "excel-upload",
              style: _vm.maxheight,
              attrs: {
                flat: "",
                bordered: "",
                "with-credentials": "",
                capture: "environment",
                "field-name": "file",
                method: "POST",
                label: "Excel 업로드",
                "auto-upload": false,
                "hide-upload-btn": true,
                multiple: false,
                accept: "xlsx",
                "max-file-size": 100000000,
                "max-total-size": 100000000,
                "max-files": 1,
                "no-thumbnails": false,
                disable: !_vm.excelEditable || _vm.isValidating,
              },
              on: { rejected: _vm.rejected, added: _vm.added },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function (scope) {
                    return [
                      _c(
                        "div",
                        { staticClass: "row no-wrap items-center q-pa-none" },
                        [
                          scope.isUploading || _vm.isValidating
                            ? _c("q-spinner", {
                                staticClass: "q-uploader__spinner",
                              })
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "col",
                              staticStyle: {
                                "padding-top": "0px !important",
                                "margin-top": "0px !important",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "q-uploader__title inline-block",
                                  staticStyle: {
                                    padding: "4px 0px !important",
                                    "font-size": "0.95em !important",
                                  },
                                },
                                [_vm._v(" Excel 업로드 ")]
                              ),
                              _vm._v("    "),
                              _vm.excelEditable
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "q-uploader__subtitle inline-block",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.uploadSizeLabel) +
                                          " / " +
                                          _vm._s(scope.uploadProgressLabel) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm.excelEditable && _vm.isTemplateDown
                            ? _c("q-btn", {
                                staticClass: "excel-upload-btn",
                                attrs: {
                                  icon: "file_download",
                                  dense: "",
                                  outline: "",
                                  size: "sm",
                                  label: "양식 다운로드",
                                },
                                on: { click: _vm.downTemplate },
                              })
                            : _vm._e(),
                          scope.queuedFiles.length > 0 && _vm.excelEditable
                            ? _c("q-btn", {
                                staticClass: "excel-upload-btn",
                                attrs: {
                                  icon: "delete",
                                  dense: "",
                                  outline: "",
                                  size: "sm",
                                  label: "파일 삭제",
                                },
                                on: { click: _vm.deleteFile },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "list",
                  fn: function (scope) {
                    return [
                      scope.files && scope.files.length > 0
                        ? [
                            _c(
                              "q-list",
                              { attrs: { separator: "" } },
                              _vm._l(scope.files, function (file) {
                                return _c(
                                  "q-item",
                                  { key: file.name },
                                  [
                                    _c(
                                      "q-item-section",
                                      [
                                        _c(
                                          "q-item-label",
                                          {
                                            staticClass: "full-width ellipsis",
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(file.name) + " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "q-item-label",
                                          { attrs: { caption: "" } },
                                          [
                                            _vm._v(
                                              " Status: " +
                                                _vm._s(file.__status) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "q-item-label",
                                          { attrs: { caption: "" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(file.__sizeLabel) +
                                                " / " +
                                                _vm._s(file.__progressLabel) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "empty_dscription" },
                              [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.excelEditable,
                                        expression: "excelEditable",
                                      },
                                    ],
                                    staticStyle: {
                                      "text-align": "center",
                                      "padding-bottom": "5px",
                                    },
                                  },
                                  [
                                    _c(
                                      "q-chip",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          outline: "",
                                          square: "",
                                          icon: "info",
                                        },
                                      },
                                      [_vm._v(" Drag or Click ")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "q-pl-md txtfileinfo",
                                    staticStyle: { "text-align": "left" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "text-positive" },
                                      [_vm._v(" 업로드 가능 확장자 ")]
                                    ),
                                    _vm._v(" : xlsx "),
                                    _c("br"),
                                    _c(
                                      "span",
                                      { staticClass: "text-positive" },
                                      [_vm._v(" 업로드 가능 파일 수 ")]
                                    ),
                                    _vm._v(" : 1 "),
                                    _c("br"),
                                    _c(
                                      "span",
                                      { staticClass: "text-positive" },
                                      [_vm._v(" 허용 파일 크기 ")]
                                    ),
                                    _vm._v(" : 100MB "),
                                  ]
                                ),
                                _c("q-uploader-add-trigger"),
                              ],
                              1
                            ),
                          ],
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-8" },
          [
            _c("c-card", {
              staticClass: "cardClassDetailForm excel-upload-status-card",
              attrs: { title: "업로드 현황", height: "164px" },
              scopedSlots: _vm._u([
                {
                  key: "card-button",
                  fn: function () {
                    return [
                      _vm.excelEditable
                        ? _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _c("c-btn", {
                                attrs: {
                                  label: "업로드 완료",
                                  icon: "check",
                                  disabled: _vm.isValidating || _vm.isSaving,
                                },
                                on: {
                                  btnClicked: function ($event) {
                                    return _vm.saveUpload(true)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "card-detail",
                  fn: function () {
                    return [
                      _c(
                        "q-inner-loading",
                        { attrs: { showing: _vm.isValidating } },
                        [
                          _c("q-spinner-ball", {
                            staticClass: "regul-db-spinner",
                            attrs: { size: "3em" },
                          }),
                        ],
                        1
                      ),
                      _c("span", {
                        staticClass: "text-grey-9 q-pa-sm",
                        staticStyle: { "font-size": "0.95em" },
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$comm.convertEnter(_vm.uploadMessage)
                          ),
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c("c-tab", {
              attrs: {
                type: "tabcard",
                align: "left",
                tabItems: _vm.tabItems,
                inlineLabel: true,
                height: _vm.tabHeight,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (tab) {
                    return [
                      _c("c-table", {
                        ref: "excelUploadTable",
                        attrs: {
                          title: "Excel 검증 결과 목록",
                          editable: _vm.excelEditable,
                          columns: _vm.columns[Number(tab.name)],
                          data: _vm.filteredRows(Number(tab.name)),
                          gridHeight: _vm.gridHeight,
                          isExpand: true,
                          usePaging: false,
                          selection: _vm.excelEditable ? "multiple" : "none",
                          rowKey: _vm.excelUploadInfo.rowKeys[Number(tab.name)],
                          customTrClass: _vm.setTrClass,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-chip",
                              fn: function () {
                                return [
                                  _vm.newChemRows.length > 0
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "q-ml-lg text-deep-purple",
                                          staticStyle: {
                                            "font-size": "0.94em",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " ✔️ 기존 화학물질에 없는 건은 오렌지색으로 표시되며, 다음 단계에서 규제 적용 시 화학물질에 신규로 등록됩니다. (총 " +
                                              _vm._s(_vm.newChemRows.length) +
                                              " 건) "
                                          ),
                                          _c("q-chip", {
                                            staticClass: "q-ml-sm",
                                            attrs: {
                                              outline: "",
                                              square: "",
                                              clickable: "",
                                              size: "12px",
                                              color: "orange",
                                              label: _vm.newChemOnly
                                                ? "전체보기"
                                                : "신규 물질만 보기",
                                            },
                                            on: {
                                              click: function ($event) {
                                                _vm.newChemOnly =
                                                  !_vm.newChemOnly
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "table-button",
                              fn: function () {
                                return [
                                  _c(
                                    "q-btn-group",
                                    { attrs: { outline: "" } },
                                    [
                                      _vm.excelUploadInfo.data[
                                        Number(tab.name)
                                      ] &&
                                      _vm.excelUploadInfo.data[Number(tab.name)]
                                        .length > 0 &&
                                      _vm.excelEditable
                                        ? _c("c-btn", {
                                            attrs: {
                                              label: !_vm.errorDataCheck
                                                ? "에러 데이터만 확인"
                                                : "전체보기",
                                              icon: "find_in_page",
                                            },
                                            on: {
                                              btnClicked: function ($event) {
                                                _vm.errorDataCheck =
                                                  !_vm.errorDataCheck
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.excelUploadInfo.data[
                                        Number(tab.name)
                                      ] &&
                                      _vm.excelUploadInfo.data[Number(tab.name)]
                                        .length > 0 &&
                                      _vm.excelEditable
                                        ? _c("c-btn", {
                                            attrs: {
                                              label: "제외",
                                              icon: "remove",
                                            },
                                            on: {
                                              btnClicked: function ($event) {
                                                return _vm.removeData(tab.name)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "expand-header",
                              fn: function () {
                                return [_vm._v(" 에러 상세 ")]
                              },
                              proxy: true,
                            },
                            {
                              key: "expand-td",
                              fn: function (props) {
                                return [
                                  _c("c-card", {
                                    staticClass: "excel-upload-status-card",
                                    attrs: { noHeader: true },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "card-detail",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "col-12" },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$comm.convertEnter(
                                                          props.row
                                                            .error_message
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            }),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }